import { Component, computed, input, Input, InputSignal, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead, LocationDecisionAppEntityLocationDecisionWrite,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import { ParcelsPreviewComponent } from '../../common/components/parcels/parcels-preview/parcels-preview.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';
import {
  LocationDecisionsPreviewComponent
} from '../../common/components/location-decisions/location-decisions-preview/location-decisions-preview.component';

@Component({
  selector: 'app-occupation-of-lane-placement-construction-objects-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent,
    ContractorDataPreviewComponent,
    LocationDecisionsPreviewComponent
  ],
  templateUrl: './occupation-of-lane-placement-construction-objects-preview.component.html'
})
export class OccupationOfLanePlacementConstructionObjectsPreviewComponent {
  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public locationDecisions: Signal<LocationDecisionAppEntityLocationDecisionWrite[]> = computed(() => this.application()?.locationDecisions?.map(v => ({
    roadOccupation: v?.roadOccupation?.uuid || '',
    decisionDate: v?.decisionDate,
    decisionNumber: v?.decisionNumber
  })) || []);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);
}
